var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.5,
    height: 62.5,
    viewBox: "0 0 231.746 250.819",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1",
    "data-name": "Grupo 1",
    transform: "translate(-181.765 -208.163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1",
    "data-name": "Trazado 1",
    d: "M395.879,409.488c-14.615,30.82-53.024,49.494-98.108,49.494-33.181,0-62.724-10.131-81.85-27.758,27.922-18.1,69.435-29.573,115.795-29.573A258.46,258.46,0,0,1,395.879,409.488Z",
    fill: "#5f9f17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2",
    "data-name": "Trazado 2",
    d: "M368.634,297.917a9.906,9.906,0,1,1,0-19.813,25.064,25.064,0,0,0,0-50.128H226.642a25.064,25.064,0,0,0,0,50.128,9.906,9.906,0,1,1,0,19.813,44.877,44.877,0,1,1,0-89.754H368.634a44.877,44.877,0,0,1,0,89.754Z",
    fill: "#5f9f17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3",
    "data-name": "Trazado 3",
    d: "M247.986,305.455c-4.755-8.155-5.976-19.212,8.984-31.287,4.686-3.782,16.75-11.341,25.3-7.964,7.561,2.988,10.953,14.2,15.267,18.886l1.977-2.294c2.69-3.756,7.508-15.421,15.3-17.166,8.99-2.016,19.568,5.29,24.705,9.651,14.093,11.966,12.729,22.407,7.956,30.139,32.584,14.538,54.711,42.926,54.711,75.567a67.21,67.21,0,0,1-2.547,18.423c-23.186-7.906-50.486-12.47-79.714-12.47-46.594,0-88.29,11.593-116.216,29.848a65.6,65.6,0,0,1-10.352-35.8C193.357,348.373,215.446,320.005,247.986,305.455ZM304.9,313.43a5.017,5.017,0,0,0,5.465,1.089c.444-.184,18.581-9.25,20.01-10.679a11.232,11.232,0,0,0-15.885-15.885c-1.434,1.435-10.535,19.634-10.722,20.117A5.016,5.016,0,0,0,304.9,313.43ZM264.9,303.84c1.43,1.429,19.567,10.495,20.011,10.679a5.017,5.017,0,0,0,6.6-6.447c-.187-.483-9.287-18.682-10.722-20.117A11.232,11.232,0,0,0,264.9,303.84Z",
    fill: "#5f9f17"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ece0f48e58a08291e39c9f329f3bdfac.svg";
export { ForwardRef as ReactComponent };